import { render, staticRenderFns } from "./PopupAddNewPage.vue?vue&type=template&id=c94793aa&scoped=true&"
import script from "./PopupAddNewPage.vue?vue&type=script&lang=js&"
export * from "./PopupAddNewPage.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddNewPage.vue?vue&type=style&index=0&id=c94793aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94793aa",
  null
  
)

export default component.exports